import { useEffect } from "react";

// Loads GA4, Microsoft Clarity, and LinkedIn Insight Tag based on env vars.
// Each script is a no-op when its env var is missing — safe to ship.

function loadGA4(id) {
  if (window.__ga4Loaded) return;
  window.__ga4Loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", id, { send_page_view: true });
}

function loadClarity(id) {
  if (window.__clarityLoaded) return;
  window.__clarityLoaded = true;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", id);
}

function loadLinkedIn(partnerId) {
  if (window.__liLoaded) return;
  window.__liLoaded = true;
  window._linkedin_partner_id = partnerId;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(partnerId);
  const s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
  document.head.appendChild(s);
}

function loadHubSpot(portalId) {
  if (window.__hsLoaded) return;
  window.__hsLoaded = true;
  const s = document.createElement("script");
  s.id = "hs-script-loader";
  s.async = true;
  s.defer = true;
  s.src = `https://js.hs-scripts.com/${portalId}.js`;
  document.head.appendChild(s);
}

export default function AnalyticsProvider() {
  useEffect(() => {
    const ga = process.env.REACT_APP_GA4_ID;
    const cl = process.env.REACT_APP_CLARITY_ID;
    const li = process.env.REACT_APP_LINKEDIN_PARTNER_ID;
    const hs = process.env.REACT_APP_HUBSPOT_PORTAL_ID;
    if (ga) loadGA4(ga);
    if (cl) loadClarity(cl);
    if (li) loadLinkedIn(li);
    if (hs) loadHubSpot(hs);
  }, []);
  return null;
}
